/* Spanish catalog mirroring locale-payroll-runs-fr-part2.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'pay.salaryTypeSaved': 'Tipo de salario guardado.',
  'pay.salaryTypeSaveFailed': 'No se pudo guardar el tipo de salario.',
  'pay.fixedLineSaved': 'Línea salarial fija guardada.',
  'pay.fixedLineSaveFailed': 'No se pudo guardar la línea salarial fija.',
  'pay.fillNameAndAccountNumber': 'Rellena el nombre y el número de cuenta.',
  'pay.accountAdded': 'Cuenta añadida.',
  'pay.addAccountFailed': 'No se pudo añadir la cuenta.',
  'pay.calculationCodeNotSupported': 'Este código de cálculo de la cotización del empleador aún no es compatible. Elige Industrias generales.',
  'pay.payrollSettingsSaved': 'Ajustes de nómina guardados.',
  'pay.payrollSettingsSavedWithRecalc': 'Ajustes de nómina guardados. Se han recalculado {count} borradores de nómina abiertos.',
  'pay.payrollSettingsSaveFailed': 'No se pudieron guardar los ajustes de nómina.',
  'pay.markedManualSubmission': 'Marcado como envío manual.',
  'pay.ameldingSentToAltinn': 'A-melding enviada a Altinn.',
  'pay.payslipsCreatedAndPosted': 'Recibos de nómina creados y nómina contabilizada. Los recibos de nómina se pueden enviar más tarde.',
  'pay.payrollRunEditableAgain': 'El proceso de nómina se puede volver a editar.',
  'pay.accountingAnnulled': 'El asiento contable se ha anulado.',
  'pay.payrollRunAnnulled': 'Proceso de nómina anulado.',
  'pay.payoutRegistered': 'Pago registrado.',
  'pay.confirmAnnulPayment': '¿Anular este pago? El asiento contable se revierte para que el pago deje de incluirse.',
  'pay.hideDeletedPayrollRuns': 'Ocultar procesos de nómina eliminados',
  'pay.showDeletedPayrollRuns': 'Mostrar procesos de nómina eliminados ({count})',
  'pay.removePermanently': 'Quitar definitivamente',
  'pay.removeDeletedPayrollRunPermanently': 'Quitar definitivamente el proceso de nómina eliminado',
  'pay.confirmRemoveDeletedPayrollRunTitle': '¿Quitar el proceso de nómina eliminado?',
  'pay.confirmRemoveDeletedPayrollRunMessage': 'Esto quita definitivamente el borrador de {period}. Aquí solo se puede quitar la nómina que nunca se ha aprobado, enviado ni contabilizado.',
  'pay.editPaymentTitle': 'Editar pago',
  'pay.registerPaymentTitle': 'Registrar pago',
  'pay.savingEllipsis': 'Guardando...',
  'pay.savePaymentAction': 'Guardar pago',
  'pay.editSalaryTypeTitle': 'Editar tipo de salario',
  'pay.newFixedLineTitle': 'Nueva línea salarial fija',
  'pay.editFixedLineTitle': 'Editar línea salarial fija',
  'pay.operatingAccount': 'Cuenta operativa',
  'pay.newWithholdingAccountTitle': 'Nueva cuenta de retención de impuestos',
  'pay.newPayrollAccountTitle': 'Nueva cuenta de nómina',
  'pay.addAccountAction': 'Añadir cuenta',
  'pay.totalPay': 'Salario total',
  'pay.taxDeduction': 'Impuestos retenidos',
  'pay.voucher': 'Justificante',
  'pay.basis': 'Base',
  'pay.payrollRuns': 'Procesos de nómina',
  'pay.agaOfHolidayPayFull': 'Cotización del empleador sobre vacaciones pagadas',
  'pay.deadline': 'Plazo',
  'pay.paidAmount': 'Pagado',
  'pay.remaining': 'Pendiente',
  'pay.provider': 'Proveedor',
  'pay.orgNumber': 'N.º org.',
  'pay.earnedAtStandardRate': 'Devengado (10,2 %)',
  'pay.ameldingRegistered': 'A-melding registrada',
  'pay.noSubmissions': 'Sin envíos',
  'pay.posted': 'Contabilizado',
  'pay.notPosted': 'No contabilizado',
  'pay.payslipsNotGenerated': 'No se han generado recibos de nómina.',
  'pay.employmentSetOnEmployeePage': 'La relación laboral se define en la página del empleado',
  'pay.rulesFromSalaryType': 'Reglas del tipo de salario',
  'pay.useStandardRules': 'Usar reglas estándar',
  'pay.advancedSettings': 'Ajustes avanzados',
  'pay.overrideCanChangeCalculation': 'La anulación puede cambiar los impuestos, la cotización del empleador, las vacaciones pagadas, la OTP y la contabilización de esta línea.',
  'pay.removeFromFixedLines': 'Quitar de las líneas salariales fijas',
  'pay.makeThisAFixedLine': 'Convertir en línea salarial fija',
  'pay.withholdingExceedsCashPayWarning': 'La retención en origen es superior al salario en efectivo y los reembolsos. Añade salario en efectivo o reduce la retención antes de poder aprobar el proceso de nómina.',
  'pay.attachDocumentationHint': 'Adjunta documentación del proceso de nómina, por ejemplo hojas de horas o solicitudes de viaje manuales.',
  'pay.upload': 'Subir',
  'pay.step1AltinnHelp': 'Cuando todas las líneas estén incluidas, el siguiente paso es declarar el proceso de nómina. La integración con Altinn se conectará más adelante, así que por ahora el envío se puede marcar como manual.',
  'pay.step3PayslipsHelp': 'Una vez declarado y aprobado el proceso de nómina, se crean los recibos de nómina y se contabiliza la nómina.',
  'pay.step4PaymentHelp': 'Registra y contabiliza el pago del salario a los empleados y de la retención en origen a la administración tributaria.',
  'pay.payrollRunCompletesWhenPaid': 'El proceso de nómina se completa cuando se registra el pago.',
  'pay.productionSupportedProfile': 'Perfil compatible en producción: nómina noruega, periodo mensual, Industrias generales y tarjetas fiscales de porcentaje. Las tarjetas fiscales basadas en tablas, los códigos especiales de cotización del empleador y el envío electrónico sin acuse de recibo están bloqueados.',
  'pay.searchMunicipalityOrNumber': 'Buscar municipio o número',
  'pay.notSupportedYet': 'aún no compatible',
  'pay.chooseGeneralIndustriesWarning': 'Elige Industrias generales antes de poder guardar los ajustes. El código de cálculo elegido anteriormente no está implementado.',
  'pay.searchProvider': 'Buscar proveedor',
  'pay.month.may': 'Mayo',
  'pay.payTypeNotFixedLine': 'Este tipo de salario no se puede usar como línea salarial fija.',
  'pay.calculationCodeUnsupportedShort': 'Este código de cálculo de la cotización del empleador aún no es compatible.',
  'pay.overtimePay': 'Horas extra',
  'pay.mileageAllowance': 'Kilometraje',
  'pay.driveFallback': 'Desplazamiento',
  'pay.taxableMileagePortion': 'Parte imponible',
  'pay.expenseCategoryOther': 'Otros',
  'pay.overnightStayFallback': 'Pernoctación',
  'pay.hotelFallback': 'Hotel',
  'pay.mileagePayoutFallback': 'Kilometraje',
  'pay.ownCar': 'Coche propio',
  'pay.travelPurposeFallback': 'Viaje',
  'pay.taxTermWithholdingLabel': 'Retención en origen {{date}}',
  'pay.taxTermAgaLabel': 'Plazo {{term}}',
  'pay.payrollRunNotEditableForNewLines': 'A un proceso de nómina aprobado no se le pueden añadir nuevas líneas salariales.',
  'pay.payTypeNotManualEntry': 'Este tipo de salario no se puede añadir manualmente.',
  'pay.receiptInboxFallbackName': 'Justificante de la bandeja de entrada',
  'pay.approvedButPayslipsFailed': 'La nómina se ha contabilizado, pero los recibos de nómina no se enviaron: {{error}}',
  'pay.recon.runLabelPeriod': 'Nómina {{period}}',
  'pay.recon.runLabelRun': 'Proceso {{date}}',
  'pay.recon.notPaid': 'Sin pagar',
  'pay.recon.paidAfterPeriod': 'Pagado después de la fecha del periodo',
  'pay.recon.flag.negativ_netto': 'Salario neto negativo',
  'pay.recon.flag.mangler_skattekort': 'Falta la tarjeta fiscal',
  'pay.recon.flag.sluttet_ansatt': 'Pago a un antiguo empleado',
  'pay.recon.flag.naturalytelse': 'Retribución en especie por revisar',
  'pay.recon.flag.uvanlig_endring': 'Cambio salarial inusual',
  'pay.recon.flag.mangler_amelding': 'Falta en la a-melding',
  'pay.recon.flag.mulig_duplikat': 'Posible pago duplicado',
  'pay.recon.flag.ikke_utbetalt': 'Sin pagar',
  'pay.recon.unknownEmployee': 'Empleado desconocido',
  'pay.recon.employmentTypeFixed': 'Indefinido',
  'pay.recon.reported': 'Declarado',
  'pay.recon.notReported': 'No declarado',
  'pay.recon.afterPeriodDate': 'Después de la fecha del periodo',
  'pay.recon.role.forskuddstrekk': 'Retención en origen del periodo',
  'pay.recon.role.aga': 'Cotización del empleador calculada sobre el salario',
  'pay.recon.role.aga_feriepenger': 'Cotización del empleador calculada sobre las vacaciones pagadas',
  'pay.recon.role.feriepenger': 'Pasivo por vacaciones pagadas según el sistema de nómina',
  'pay.recon.role.skyldig_lonn': 'Salario neto y deducciones del sistema de nómina',
  'pay.recon.role.pensjon': 'Prima de pensión del sistema de nómina',
  'pay.recon.row.brutto': 'Salario bruto',
  'pay.recon.row.naturalytelser': 'Retribuciones en especie imponibles',
  'pay.recon.row.trekkpliktige': 'Deducciones imponibles',
  'pay.recon.row.godtgjorelser': 'Indemnizaciones por gastos',
  'pay.recon.row.aga_grunnlag': 'Base de la cotización del empleador',
  'pay.recon.row.aga': 'Cotización del empleador calculada',
  'pay.recon.row.netto': 'Salario neto',
  'pay.recon.row.andre_trekk': 'Otras deducciones',
  'pay.recon.row.feriepenger': 'Vacaciones pagadas devengadas',
  'pay.recon.row.pensjon': 'Prima de pensión',
  'pay.recon.source.payrollSystem': 'Sistema de nómina',
  'pay.recon.source.bankPayouts': 'Pagos bancarios',
  'pay.recon.source.pensionBasis': 'Base de pensión',
  'pay.recon.source.payrollSystemDetailSingular': '{{count}} proceso contabilizado en el periodo',
  'pay.recon.source.payrollSystemDetailPlural': '{{count}} procesos contabilizados en el periodo',
  'pay.recon.source.payrollSystemDetailEmpty': 'No hay procesos de nómina contabilizados en el periodo',
  'pay.recon.source.ledgerDetail': '{{count}} asientos en las cuentas de nómina',
  'pay.recon.source.ledgerDetailEmpty': 'No hay asientos en las cuentas añadidas al área de nómina',
  'pay.recon.source.ameldingDetailNone': 'No hay procesos que declarar',
  'pay.recon.source.ameldingDetailAllReported': '{{reported}} de {{total}} procesos están registrados como declarados',
  'pay.recon.source.ameldingDetailMissing': '{{missing}} de {{total}} procesos no están registrados como declarados',
  'pay.recon.source.bankDetailNone': 'No hay procesos que pagar',
  'pay.recon.source.bankDetailPaid': '{{paid}} de {{total}} procesos están registrados como pagados',
  'pay.recon.source.pensionDetailPresent': 'Prima de pensión calculada por el sistema de nómina',
  'pay.recon.source.pensionDetailNone': 'No hay prima de pensión en el periodo',
  'pay.recon.check.bokfort': 'Todos los procesos de nómina están contabilizados',
  'pay.recon.check.hovedbok': 'El sistema de nómina coincide con el libro mayor',
  'pay.recon.check.kontrollkontoer': 'Las cuentas de control coinciden con la base',
  'pay.recon.check.bank': 'El salario neto se ha pagado',
  'pay.recon.check.amelding': 'La a-melding está registrada como enviada',
  'pay.recon.check.skattekort': 'Todos los empleados tienen una tarjeta fiscal válida',
  'pay.recon.check.negativ': 'No hay importes netos negativos',
  'pay.recon.check.duplikat': 'Se han identificado los posibles pagos duplicados',
  'pay.recon.check.uvanlig': 'Se han identificado los cambios salariales inusuales',
  'pay.recon.check.sluttet': 'Se han identificado los pagos a antiguos empleados',
  'pay.recon.check.naturalytelse': 'Se han analizado las retribuciones en especie',
  'pay.recon.check.feriepenger': 'El pasivo por vacaciones pagadas está conciliado',
  'pay.recon.check.termin': 'La retención en origen y la cotización del empleador están liquidadas',
  'pay.creatingRun': 'Creando…',
  'pay.pensionPremiumAmount': 'Prima de pensión real',
  'pay.pensionBankAmount': 'Pagado desde el banco',
  'pay.pensionFeeAmount': 'Comisión aparte (bruta)',
  'pay.pensionFeeVat': 'IVA de la comisión',
  'pay.pensionFeeAccount': 'Cuenta de gasto de la comisión',
  'pay.pensionOverpaymentNotice': 'La diferencia se contabiliza como un pago anticipado al proveedor de pensiones en la cuenta 1570.',
  'pay.createLaterCorrection': 'Crear corrección en un periodo posterior',
  'pay.createCorrection': 'Crear corrección',
  'pay.laterCorrectionHelp': 'Se conserva el proceso original. Al aprobar la corrección solo se contabiliza la diferencia.',
  'pay.correctionCreated': 'El proceso de corrección se ha creado como borrador.',
  'pay.typeStandard': 'Estándar',
  'pay.typeCustom': 'Personalizado',
  'pay.statusInactive': 'Inactivo',
  'pay.ruleTag.aga': 'Cot. emp.',
  'pay.ruleTag.tax': 'Impuestos',
  'pay.ruleTag.holiday': 'Vac. pag.',
  'pay.ruleTag.pension': 'OTP',
  'pay.ruleTitle.aga': 'Sujeto a la cotización del empleador',
  'pay.ruleTitle.tax': 'Sujeto a retención en origen',
  'pay.ruleTitle.holiday': 'Base de vacaciones pagadas',
  'pay.ruleTitle.pension': 'Base de pensión',
  'pay.stdType.monthly-salary': 'Salario fijo',
  'pay.stdType.hourly': 'Salario por hora: sin horas extra',
  'pay.stdType.overtime-hourly': 'Salario por hora: horas extra',
  'pay.stdType.commission-pay': 'Honorarios, destajo, porcentaje o comisiones',
  'pay.stdType.bonus-holiday-pay': 'Bonus, devenga vacaciones pagadas',
  'pay.stdType.bonus-no-holiday-pay': 'Bonus, no devenga vacaciones pagadas',
  'pay.stdType.board-fee': 'Dietas de consejo',
  'pay.stdType.company-car': 'Coche de empresa',
  'pay.stdType.other-benefits': 'Otras retribuciones',
  'pay.stdType.taxable-insurance': 'Seguro, parte imponible',
  'pay.stdType.car-km-allowance': 'Kilometraje',
  'pay.stdType.car-km-allowance-taxable': 'Kilometraje, parte imponible',
  'pay.stdType.holiday-pay-current': 'Vacaciones pagadas devengadas en el año en curso',
  'pay.stdType.holiday-pay-previous': 'Vacaciones pagadas devengadas en años anteriores',
  'pay.stdType.pension-premium': 'Prima de pensión (OTP)',
  'pay.stdType.canteen-deduction': 'Deducción de comedor',
  'pay.stdType.holiday-deduction': 'Deducción salarial por vacaciones',
  'pay.stdType.extra-tax-deduction': 'Deducción adicional de impuestos',
  'pay.stdType.employee-expense-settlement': 'Reembolso de gastos de viaje',
  'pay.stdType.overnight-diet-hotel': 'Dieta por pernoctación (hotel)',
});
